import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Phongban} from '../model/Phongban';
import { Loaivanban} from '../model/Loaivanban';
import { User} from '../model/User';
import { DattaConfig} from '../app-config';
import { Coquanbanhanh } from '../model/Coquanbanhanh';
import { Linhvuc } from '../model/Linhvuc';
import { SysUserGroup } from '../model/Sysusergroup';
import { Sysuser } from '../model/Sysuser';
import { Sysaction } from '../model/Sysaction';
import { Sysfunction } from '../model/Sysfunction';
import { Sysfunctiongroup } from '../model/Sysfunctiongroup';
import { SysRole } from '../model/Sysrole';
import { Sysrolefunction } from '../model/Sysrolefunction';
import { SysUserPermisson } from '../model/SysUserPermisson';
import { SysUserGroupPermisson } from '../model/SysUserGroupPermisson';


@Injectable({
  providedIn: 'root'
})
export class HttpClientService {
  public dattaConfig: any;
  token: string;
  httpOptions: any;


  constructor(private httpClient: HttpClient) { 
    this.dattaConfig = DattaConfig.config;   
  }

  ngOnInit(): void {
   
  }
  //danh mục phòng ban
  getPhongban() {
    //return this.httpClient.get<Phongban[]>('http://localhost:8080/phongban/get');
    return this.httpClient.get<Phongban[]>(this.dattaConfig['httplink'] + '/phongban/get');
  }
  addPhongban(newPB: Phongban) {
    //return this.httpClient.post<Phongban>('http://localhost:8080/phongban/add', newPB);
   
    return this.httpClient.post<Phongban>(this.dattaConfig['httplink'] + '/phongban/add', newPB);
  }
  deletePhongban(id) {
    //return this.httpClient.delete<Phongban>('http://localhost:8080/phongban/' + id);
    return this.httpClient.delete<Phongban>(this.dattaConfig['httplink'] + '/phongban/' + id);
  }

  updatePhongban(updatedPB: Phongban) {
    //return this.httpClient.put<Phongban>('http://localhost:8080/phongban/update', updatedPB);
   // console.log("hieuluc=" + updatedPB.hieuluc);
    return this.httpClient.put<Phongban>(this.dattaConfig['httplink'] + '/phongban/update', updatedPB);
  }
  //end danh mục phòng ban
  //danh mục loại văn bản
  getLoaivanban() {
    return this.httpClient.get<Loaivanban[]>(this.dattaConfig['httplink'] + '/loaivanban/get');
  }
  addLoaivanban(newLoaiVB: Loaivanban) {
    return this.httpClient.post<Loaivanban>(this.dattaConfig['httplink'] + '/loaivanban/add', newLoaiVB);
  }
  deleteLoaivanban(id) {
    return this.httpClient.delete<Loaivanban>(this.dattaConfig['httplink'] + '/loaivanban/' + id);
  }

  updateLoaivanban(updatedLoaiVB: Loaivanban) {
    return this.httpClient.put<Loaivanban>(this.dattaConfig['httplink'] + '/loaivanban/update', updatedLoaiVB);
  }
  //end danh mục loại văn bản

  //danh mục user
  getUser() {
    return this.httpClient.get<User[]>(this.dattaConfig['httplink'] + '/user/get');
  }
  addUser(newUser: User) {
    return this.httpClient.post<User>(this.dattaConfig['httplink'] + '/user/add', newUser);
  }
  deleteUser(id) {
    return this.httpClient.delete<User>(this.dattaConfig['httplink'] + '/user/' + id);
  }

  updateUser(updatedUser: User) {
    return this.httpClient.put<User>(this.dattaConfig['httplink'] + '/user/update', updatedUser);
  }
  //end danh mục user

  //Long Coquanbanhanh
  getCoquanbanhanh() {
    return this.httpClient.get<Coquanbanhanh[]>(this.dattaConfig['httplink'] + '/coquanbanhanh/get');
  }
  addCoquanbanhanh(newCQBH: Coquanbanhanh) { 
    return this.httpClient.post<Coquanbanhanh>(this.dattaConfig['httplink'] + '/coquanbanhanh/add', newCQBH);
  }
  deleteCoquanbanhanh(id) {
    return this.httpClient.delete<Coquanbanhanh>(this.dattaConfig['httplink'] + '/coquanbanhanh/' + id);
  }

  updateCoquanbanhanh(updatedCQBH: Coquanbanhanh) {
    return this.httpClient.put<Coquanbanhanh>(this.dattaConfig['httplink'] + '/coquanbanhanh/update', updatedCQBH);
  }

  //Long Linhvuc
  getLinhvuc() {
    return this.httpClient.get<Linhvuc[]>(this.dattaConfig['httplink'] + '/linhvuc/get');
  }
  addLinhvuc(newLV: Linhvuc) { 
    return this.httpClient.post<Linhvuc>(this.dattaConfig['httplink'] + '/linhvuc/add', newLV);
  }
  deleteLinhvuc(id) {
    return this.httpClient.delete<Linhvuc>(this.dattaConfig['httplink'] + '/linhvuc/' + id);
  }

  updateLinhvuc(updatedLV: Linhvuc) {
    return this.httpClient.put<Linhvuc>(this.dattaConfig['httplink'] + '/linhvuc/update', updatedLV);
  }


  //Long System Configutation

      //NhomNguoiDung
        getSysUserGroup() {
          return this.httpClient.get<SysUserGroup[]>(this.dattaConfig['httplink'] + '/sysUserGroup/get');
        }
        addSysUserGroup(newsysUserGroup: SysUserGroup) { 
          return this.httpClient.post<SysUserGroup>(this.dattaConfig['httplink'] + '/sysUserGroup/add', newsysUserGroup);
        }
        deleteSysUserGroup(id) {
          return this.httpClient.delete<SysUserGroup>(this.dattaConfig['httplink'] + '/sysUserGroup/' + id);
        }  
        updateSysUserGroup(updatedsysUserGroup: SysUserGroup) {
          return this.httpClient.put<SysUserGroup>(this.dattaConfig['httplink'] + '/sysUserGroup/update', updatedsysUserGroup);
        }
      //End NhomNguoiDung
      
      //User
        getSysUser() {
          return this.httpClient.get<Sysuser[]>(this.dattaConfig['httplink'] + '/sysUser/get');
        }
        addSysUser(newsysUser: Sysuser) { 
          return this.httpClient.post<Sysuser>(this.dattaConfig['httplink'] + '/sysUser/add', newsysUser);
        }
        deleteSysUser(id) {
          return this.httpClient.delete<Sysuser>(this.dattaConfig['httplink'] + '/sysUser/' + id);
        }   
        updateSysUser(updatedsysUser: Sysuser) {
          return this.httpClient.put<Sysuser>(this.dattaConfig['httplink'] + '/sysUser/update', updatedsysUser);
        }
        chectrunguser(username: string) {
          return this.httpClient.get<Boolean>(this.dattaConfig['httplink'] + `/sysUser/checkexist/${username}`);
        }
        changepwSysUser(updatedsysUser: Sysuser) {
          return this.httpClient.put<Sysuser>(this.dattaConfig['httplink'] + '/sysUser/changepw', updatedsysUser);
        }
        getSysUserByUserName(username: string) {
          return this.httpClient.get<Sysuser[]>(this.dattaConfig['httplink'] + '/sysUser/get/' + username);
        }
        //End User

        //sysAction
        getSysAction() {
          return this.httpClient.get<Sysaction[]>(this.dattaConfig['httplink'] + '/sysAction/get');
        }
        addSysAction(newsysAction: Sysaction) { 
          return this.httpClient.post<Sysaction>(this.dattaConfig['httplink'] + '/sysAction/add', newsysAction);
        }
        deleteSysAction(id) {
          return this.httpClient.delete<Sysaction>(this.dattaConfig['httplink'] + '/sysAction/' + id);
        }   
        updateSysAction(updatedsysAction: Sysaction) {
          return this.httpClient.put<Sysaction>(this.dattaConfig['httplink'] + '/sysAction/update', updatedsysAction);
        }
        //End sysAction

        //SysFunction
        getSysFunction() {
          return this.httpClient.get<Sysfunction[]>(this.dattaConfig['httplink'] + '/sysFunction/get');
        }
        addSysFunction(newsysFunction: Sysfunction) { 
          return this.httpClient.post<Sysfunction>(this.dattaConfig['httplink'] + '/sysFunction/add', newsysFunction);
        }
        deleteSysFunction(id) {
          return this.httpClient.delete<Sysfunction>(this.dattaConfig['httplink'] + '/sysFunction/' + id);
        }   
        updateSysFunction(updatedsysFunction: Sysfunction) {
          return this.httpClient.put<Sysfunction>(this.dattaConfig['httplink'] + '/sysFunction/update', updatedsysFunction);
        }
        //End SysFunction

        //SysFunctionGroup
        getSysFunctionGroup() {
          return this.httpClient.get<Sysfunctiongroup[]>(this.dattaConfig['httplink'] + '/sysFunctionGroup/get');
        }
        addSysFunctionGroup(newsysFunctionGroup: Sysfunctiongroup) { 
          return this.httpClient.post<Sysfunctiongroup>(this.dattaConfig['httplink'] + '/sysFunctionGroup/add', newsysFunctionGroup);
        }
        deleteSysFunctionGroup(id) {
          return this.httpClient.delete<Sysfunctiongroup>(this.dattaConfig['httplink'] + '/sysFunctionGroup/' + id);
        }   
        updateSysFunctionGroup(updatedsysFunctionGroup: Sysfunctiongroup) {
          return this.httpClient.put<Sysfunctiongroup>(this.dattaConfig['httplink'] + '/sysFunctionGroup/update', updatedsysFunctionGroup);
        }
        //End SysFunctionGroup

        //SysRole
        getSysRole() {
          return this.httpClient.get<SysRole[]>(this.dattaConfig['httplink'] + '/sysRole/get');
        }
        addSysRole(newsysRole: SysRole) { 
          return this.httpClient.post<SysRole>(this.dattaConfig['httplink'] + '/sysRole/add', newsysRole);
        }
        deleteSysRole(id) {
          return this.httpClient.delete<SysRole>(this.dattaConfig['httplink'] + '/sysRole/' + id);
        }   
        updateSysRole(updatedsysRole: SysRole) {
          return this.httpClient.put<SysRole>(this.dattaConfig['httplink'] + '/sysRole/update', updatedsysRole);
        }
        //End SysRole

        getSysRoleFunction(id) {
          return this.httpClient.get<Sysrolefunction[]>(this.dattaConfig['httplink'] + '/sysRoleFunction/get/'+ id);
        }
        updateSysRoleFunction(updatedsysRoleFunction: Sysrolefunction) {
          //let body = JSON.stringify({ Sysrolefunction }); 
          //let headers = new Headers({ 'Content-Type': 'application/json' });
          //this.httpOptions
          return this.httpClient.put<Sysrolefunction>(this.dattaConfig['httplink'] + '/sysRoleFunction/update', updatedsysRoleFunction);
        }

        //get sysuserpermisson
        getSysUserPermisson(id) {
          return this.httpClient.get<SysUserPermisson[]>(this.dattaConfig['httplink'] + '/sysUserPermisson/get/'+ id);
        }
        updateSysUserPermisson(updatedSysUserPermisson: SysUserPermisson) {
          return this.httpClient.put<SysUserPermisson>(this.dattaConfig['httplink'] + '/sysUserPermisson/update', updatedSysUserPermisson);
        }
        //end sysuserpermisson

        //get sysuserGroupPermisson
        getSysUserGroupPermisson(id) {
          return this.httpClient.get<SysUserGroupPermisson[]>(this.dattaConfig['httplink'] + '/sysUserGroupPermisson/get/'+ id);
        }
        updateSysUserGroupPermisson(updatedSysUserGroupPermisson: SysUserGroupPermisson) {
          return this.httpClient.put<SysUserGroupPermisson>(this.dattaConfig['httplink'] + '/sysUserGroupPermisson/update', updatedSysUserGroupPermisson);
        }
        //end sysuserGrouppermisson
  //End Long System Configutation

  

}
